import { useScrollReveal } from '@/hooks/useScrollReveal';

const rankings = [
  { rank: 1, title: '外卖小哥暴雨中护送老人回家，全网点赞超百万', hot: '🔥', category: '社会暖心', change: 'up', views: '128万' },
  { rank: 2, title: '知名演员匿名捐款十年，被受助者认出后低调回应', hot: '🔥', category: '明星正能量', change: 'up', views: '96万' },
  { rank: 3, title: '90后女程序员辞职回乡创业，带动全村脱贫致富', hot: '🔥', category: '创业故事', change: 'new', views: '83万' },
  { rank: 4, title: '退休教师义务辅导留守儿童二十年，学生遍布名校', hot: '', category: '校园正能量', change: 'up', views: '71万' },
  { rank: 5, title: '社区志愿者连续八年为孤寡老人送温暖，感动全城', hot: '', category: '公益行动', change: 'same', views: '65万' },
  { rank: 6, title: '足球少年逆境成长，从贫民窟踢进国家队的励志之路', hot: '', category: '体育精神', change: 'down', views: '58万' },
  { rank: 7, title: '跨国情侣用镜头记录中国乡村变迁，获国际纪录片大奖', hot: '', category: '国际视野', change: 'new', views: '52万' },
];

export default function RankingSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="ranking" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-3 py-1 rounded-full mb-3">
            实时排行
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            黑料热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            本周最受关注的七条正能量黑料，看看大家都在讨论什么温暖故事
          </p>
        </div>

        <div className={`bg-background-100 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="hidden sm:flex items-center px-5 md:px-6 py-3 text-xs text-foreground-400 border-b border-background-200/50 bg-background-200/30">
            <span className="w-10 text-center">排名</span>
            <span className="flex-1 pl-2">标题</span>
            <span className="w-24 text-center">分类</span>
            <span className="w-20 text-center">热度</span>
            <span className="w-10 text-center">趋势</span>
          </div>
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className={`flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 px-5 md:px-6 py-4 hover:bg-background-200/30 transition-colors cursor-pointer ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="flex items-center gap-3 sm:w-10 sm:justify-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-heading font-bold ${
                  item.rank === 1 ? 'bg-accent-500 text-background-50 shadow-sm shadow-accent-500/30' :
                  item.rank === 2 ? 'bg-primary-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <span className="sm:hidden text-xs text-foreground-400">{item.category}</span>
                <span className="sm:hidden text-xs text-foreground-400 ml-auto">{item.views}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-900">
                  {item.hot && <span className="mr-1.5">{item.hot}</span>}
                  {item.title}
                </p>
              </div>
              <span className="hidden sm:inline-block text-xs text-foreground-400 bg-background-200/50 px-2.5 py-1 rounded-full w-24 text-center whitespace-nowrap">
                {item.category}
              </span>
              <span className="hidden sm:inline-block text-xs text-foreground-500 w-20 text-center">{item.views}</span>
              <span className="hidden sm:flex w-10 h-6 items-center justify-center">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm font-bold"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.change === 'new' && <span className="text-xs font-bold text-primary-500 bg-primary-100 px-1.5 py-0.5 rounded">新</span>}
                {item.change === 'same' && <span className="text-foreground-300 text-xs">—</span>}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}